import { getLocale } from '@nobia/zeus-components/lib/i18n'
import { polyfillIntl } from '@nobia/zeus-components/lib/polyfills'
import settings from '@nobia/zeus-components/lib/settings'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

const { locale } = getLocale(settings.brand)
polyfillIntl(locale)
